import { 
    FETCH_USERS_REQUEST,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS, 
    CREATE_USER_REQUEST,
    CREATE_USER_FAILURE,
    CREATE_USER_SUCCESS,
    DELETE_USER_SUCCESS,
    DELETE_USER_REQUEST,
    DELETE_USER_FAILURE,
    VIEW_USER_SUCCESS,
    VIEW_USER_REQUEST,
    VIEW_USER_FAILURE,
    VIEW_USER_FILES_SUCCESS,
    VIEW_USER_FILES_REQUEST,
    VIEW_USER_FILES_FAILURE,
    UPLOAD_USER_FILE_SUCCESS,
    UPLOAD_USER_FILE_REQUEST,
    UPLOAD_USER_FILE_FAILURE,
    DOWNLOAD_FILE_SUCCESS,
    DOWNLOAD_FILE_REQUEST,
    DOWNLOAD_FILE_FAILURE,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    UPDATE_USER_REQUEST,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_REQUEST,
    DELETE_FILE_FAILURE,
} from '../constants';
import { parseJSON } from '../utils/misc';
import { 
    createNewUser,
    fetchUsers,
    getUser,
    getUserFiles,
    patchPassword,
    patchUser,
    removeFile,
    removeUser,
    signFileUri,
    uploadFile,
    getPdfDataAndDisplayThemInANewWindow
} from '../utils/http_functions';
import { logoutAndRedirect } from './auth';

export function receiveProtectedData(data) {
    return {
        type: RECEIVE_PROTECTED_DATA,
        payload: {
            data,
        },
    };
}

export function fetchUsersRequest() {
    return {
        type: FETCH_USERS_REQUEST,
    };
}

export function fetchUsersFailure() {
    return {
        type: FETCH_USERS_FAILURE,
    };
}

export function fetchUsersSuccess(data) {
    return {
        type: FETCH_USERS_SUCCESS,
        payload: {
            data,
        },
    };
}

export function fetchUsersData(token) {
    return (dispatch) => {
        dispatch(fetchUsersRequest());
        fetchUsers(token)
            .then(parseJSON)
            .then(response => {
                dispatch(fetchUsersSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(fetchUsersFailure())
                }
            });
    };
}

export function createUserSuccess(user) {
    return {
        type: CREATE_USER_SUCCESS,
        payload: {
            user,
        },
    };
}

export function createUserRequest() {
    return {
        type: CREATE_USER_REQUEST,
    };
}

export function createUserFailure(error) {
    return {
        type: CREATE_USER_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function createUser(user, token) {
    return function (dispatch) {
        dispatch(createUserRequest());
        return createNewUser(user, token)
            .then(parseJSON)
            .then(response => {
                dispatch(createUserSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(createUserFailure(error))
                }
            });
    };
}

export function updateUserSuccess(user) {
    return {
        type: UPDATE_USER_SUCCESS,
        payload: {
            user,
        },
    };
}

export function updateUserRequest() {
    return {
        type: UPDATE_USER_REQUEST,
    };
}

export function updateUserFailure(error) {
    return {
        type: UPDATE_USER_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function updateUser(id, user, token) {
    return function (dispatch) {
        dispatch(updateUserRequest());
        return patchUser(id, user, token)
            .then(parseJSON)
            .then(response => {
                dispatch(updateUserSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(updateUserFailure(error))
                }
            });
    };
}

export function deleteUserSuccess(user) {
    return {
        type: DELETE_USER_SUCCESS,
        payload: {
            user,
        },
    };
}

export function deleteUserRequest() {
    return {
        type: DELETE_USER_REQUEST,
    };
}

export function deleteUserFailure(error) {
    return {
        type: DELETE_USER_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function deleteUser(id, token) {
    return function (dispatch) {
        dispatch(deleteUserRequest());
        return removeUser(id, token)
            .then(parseJSON)
            .then(response => {
                dispatch(deleteUserSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(deleteUserFailure(error))
                }
            });
    };
}

export function viewUserSuccess(user) {
    return {
        type: VIEW_USER_SUCCESS,
        payload: {
            user,
        },
    };
}

export function viewUserRequest() {
    return {
        type: VIEW_USER_REQUEST,
    };
}

export function viewUserFailure(error) {
    return {
        type: VIEW_USER_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function viewUser(id, token) {
    return function (dispatch) {
        dispatch(viewUserRequest());
        return getUser(id, token)
            .then(parseJSON)
            .then(response => {
                dispatch(viewUserSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(viewUserFailure(error))
                }
            });
    };
}

export function viewUserFilesSuccess(files) {
    return {
        type: VIEW_USER_FILES_SUCCESS,
        payload: {
            files,
        },
    };
}

export function viewUserFilesRequest() {
    return {
        type: VIEW_USER_FILES_REQUEST,
    };
}

export function viewUserFilesFailure(error) {
    return {
        type: VIEW_USER_FILES_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function viewUserFiles(id, token) {
    return function (dispatch) {
        dispatch(viewUserFilesRequest());
        return getUserFiles(id, token)
            .then(parseJSON)
            .then(response => {
                dispatch(viewUserFilesSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(viewUserFilesFailure(error))
                }
            });
    };
}

export function uploadUserFilesSuccess(files) {
    return {
        type: UPLOAD_USER_FILE_SUCCESS,
        payload: {
            files,
        },
    };
}

export function uploadUserFilesRequest() {
    return {
        type: UPLOAD_USER_FILE_REQUEST,
    };
}

export function uploadUserFilesFailure(error) {
    return {
        type: UPLOAD_USER_FILE_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function uploadUserFile(id, file, token) {
    return function (dispatch) {
        dispatch(uploadUserFilesRequest());
        return uploadFile(id, file, token)
            .then(parseJSON)
            .then(response => {
                dispatch(uploadUserFilesSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(uploadUserFilesFailure(error))
                }
            });
    };
}

export function downloadFileSuccess(url) {
    return {
        type: DOWNLOAD_FILE_SUCCESS,
        payload: {
            url,
        },
    };
}

export function downloadFileRequest() {
    return {
        type: DOWNLOAD_FILE_REQUEST,
    };
}

export function downloadFileFailure(error) {
    return {
        type: DOWNLOAD_FILE_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function downloadFile(id, token) {
    return function (dispatch) {
        dispatch(downloadFileRequest());
        return signFileUri(id, token)
            .then(parseJSON)
            .then(response => {
                dispatch(downloadFileSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(downloadFileFailure(error));
                }
            });
    };
}


export function changePassSuccess() {
    return {
        type: CHANGE_PASSWORD_SUCCESS,
    };
}

export function changePassRequest() {
    return {
        type: CHANGE_PASSWORD_REQUEST,
    };
}

export function changePassFailure(error) {
    return {
        type: CHANGE_PASSWORD_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function changePass(id, oldPass, newPass, token) {
    return function (dispatch) {
        dispatch(changePassRequest());
        return patchPassword(id, oldPass, newPass, token)
            .then(parseJSON)
            .then(response => {
                dispatch(changePassSuccess(response));
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(changePassFailure(error))
                }
            });
    };
}

export function deleteFileSuccess() {
    return {
        type: DELETE_FILE_SUCCESS,
    };
}

export function deleteFileRequest() {
    return {
        type: DELETE_FILE_REQUEST,
    };
}

export function deleteFileFailure(error) {
    return {
        type: DELETE_FILE_FAILURE,
        payload: {
            status: error.response.data.status,
            statusText: error.response.data.error,
        },
    };
}

export function deleteFile(id, token) {
    return function (dispatch) {
        dispatch(deleteFileRequest());
        return removeFile(id, token)
            .then(parseJSON)
            .then(() => {
                dispatch(deleteFileSuccess());
            })
            .catch(error => {
                if (error.status === 401) {
                    dispatch(logoutAndRedirect(error));
                } else {
                    dispatch(deleteFileFailure(error))
                }
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/user.js